import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\ContactSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\GoalsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\InterestsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\JourneySection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\NumbersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\PillarsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\BDT apps\\website_bdt\\website-template\\src\\components\\home\\SkillsSection.tsx");
